<template>
  <div class="searchcircleall">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>
    <div class="circlesobox">
      <dl>
        <dt>
          <van-search
          left-icon="https://api.xianpipa.com/xianpipa/images/contacts_icon_search.png"
            background="#f8f8f8"
            placeholder="搜索您感兴趣的圈子"
            v-model="value"
            shape="round"
            @search="onSearch"
            @input="onChange"
          />
        </dt>
        <dd @click="gotocreatcircle">
          <van-icon name="plus" />
          <span>申请圈子</span>
        </dd>
      </dl>
    </div>

    <div class="circlesosomain">
      <div class="nofollowbox" v-if="nosearchbox">
        <div class="nofollowpic">
          <img src="../../assets/images/search_no.png" />
        </div>
        <div class="nosearchtext">暂无内容</div>
      </div>
      <div v-else class="circle-cell" v-for="(item,index) in searchcircle" :key="index">
        <div class="circle-cell-pic" @click="gotocirclecontent">
          <img :src="item.avatar_url" />
        </div>
        <div class="circle-cell-name" @click="gotocirclecontent">
          <div class="cname">{{item.title}}</div>
          <div class="cconner">{{item.content}}</div>
        </div>
        <div class="circle-cell-fllow">
          <button v-if="item.is_follow == 0" :data-likeid="item.id" @click="favorclick">关注</button>
          <button v-else :data-likeid="item.id" @click="favorclick" class="active">已关注</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getsearchcircle, gettofollowcircle } from "../../api/api.js";
import navbar from "../public/navbar.vue";

import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);

export default {
  name: "searchcircle",
  components: {
    navbar
  },
  data() {
    return {
      titlename: "搜索圈子",
      value: "",
      searchcircle: [],
      nosearchbox: false
    };
  },
  created(){
    document.title='搜索圈子';
  },
  methods: {
    onSearch(e) {
      this.nosearchbox = false;
      this.getcirclelist();
    },
    //获取申请圈子的数据
    getcirclelist() {
      let that = this;
      let keyword = this.value;
      getsearchcircle(keyword).then(res => {
        if (res.data.code == 200) {
          if (res.data.data.list.length != 0) {
            that.searchcircle = res.data.data.list;
            that.nosearchbox = false;
          } else {
            that.nosearchbox = true;
          }
        }
      });
    },
    onChange() {
      if (this.value == "") {
        this.searchcircle = [];
        this.nosearchbox = false;
      }
    },
    gotocirclecontent() {},
    favorclick(e) {
      var that = this;
      var item_id = e.currentTarget.dataset.likeid;
      var show; //传递到数据库点赞的状态

      if (localStorage.getItem("okfollow")) {
        var cookie_mid = localStorage.getItem("okfollow").split(",");
      } else {
        var cookie_mid = [];
      }
      //var cookie_mid = localStorage.getItem('okfollow').split(',') || []; //获取全部点赞的mid
      var newmessage = [];

      for (var i = 0; i < that.searchcircle.length; i++) {
        if (that.searchcircle[i].id == item_id) {
          //遍历找到对应的id

          var num = that.searchcircle[i].is_follow; //当前赞数
          var isshow; //点赞的状态
          if (cookie_mid.includes(item_id) || that.searchcircle[i].is_follow) {
            //说明已经点过赞,取消赞

            for (var j = 0; j < cookie_mid.length; j++) {
              if (cookie_mid[j] == item_id) {
                cookie_mid.splice(j, 1); //删除取消赞的mid
              }
            }
            --num;
            isshow = 0; //点赞的状态
            that.searchcircle[i].is_follow = isshow;
            localStorage.setItem("okfollow", cookie_mid.join(","));
          } else {
            isshow = 1; //点赞的状态
            ++num;
            that.searchcircle[i].is_follow = isshow;
            cookie_mid.unshift(item_id); //新增赞的mid
            localStorage.setItem("okfollow", cookie_mid.join(","));
          }
        }
      }

      gettofollowcircle(item_id).then(res => {
        if (res.code == 200) {
          Toast({
            message: res.message,
            icon: "success"
          });
        } else {
          Toast.fail("关注失败！");
        }
      });
    },
    gotocreatcircle() {
      this.$router.push({
        name: "creatcircle"
      });
    }
  }
};
</script>
<style>
.van-field__control{
  font-size: 0.68rem
}
.van-search{
  padding: 0.54rem 0.64rem; 
}
.van-field__left-icon .van-icon{
  font-size: 0.86rem;
}
.van-search__content--round{
  border-radius: 0.9rem;
}
.van-search .van-cell{
      padding: 0.26rem 0.42rem 0.26rem 0;
}
</style>

<style scoped>
.navbar {
  position: relative;
  z-index: 99;
}
.searchcircleall {
}
.circlesobox {
  background: #f8f8f8;
  overflow: hidden;
  padding-top: 50px;
}
.van-search {
  background: none;
}
.circlesobox dl {
}
.circlesobox dl dt {
  float: left;
  background: #fff;
}

.circlesobox dl dd {
  float: left;
  font-size: 0.68rem;
  color: #6699ff;
  padding-top: 0.8rem; 
   line-height: 24px;
}
.circlesobox dl dd .van-icon-plus {
  float: left;
/*   margin-top: 0.15rem; */
  font-size: 0.6rem;
  margin-right: 0.1rem;
  line-height: 24px;
}
.circlesobox dl dd span {
  float: left;
}
.van-search__content {
  background: #fff;
  width: 14.1rem;
}

.circlesosomain {
  margin-left: 0.7rem;
  margin-right: 0.7rem;
}
.circlesosomain .circle-cell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
  border-bottom: 0.02702702702702703rem solid #f6f6f6;
  width: 100%;
}
.circlesosomain .circle-cell .circle-cell-pic {
  width: 2.16rem;
  height: 2.16rem;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  position: relative;
}

.circlesosomain .circle-cell .circle-cell-pic .circle-cell-pic-no {
  position: absolute;
  bottom: 0;
  background: rgba(218, 135, 70, 0.9);
  height: 0.7027027027027027rem;
  line-height: 0.7027027027027027rem;
  width: 2.16rem;
  color: #fff;
  font-size: 0.4864864864864865rem;
  text-align: center;
  border-radius: 0 0 0.2702702702702703rem 0.2702702702702703rem;
}
.circlesosomain .circle-cell .circle-cell-pic img {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
}
.circlesosomain .circle-cell .circle-cell-pic .circle-cell-pic-no img {
  width: 0.7567567567567568rem;
  height: 0.5675675675675675rem;
}
.circlesosomain .circle-cell .circle-cell-pic .circle-cell-pic-no01 {
  background: rgba(246, 210, 84, 0.9);
  color: #eb7c3a;
}
.circlesosomain .circle-cell .circle-cell-pic .circle-cell-pic-no02 {
  background: rgba(211, 224, 241, 0.9);
  color: #7a98b4;
}
.circlesosomain .circle-cell .circle-cell-pic .circle-cell-pic-no03 {
  background: rgba(238, 147, 120, 0.9);
  color: #b04b32;
}
.circlesosomain .circle-cell .circle-cell-name {
  flex: 7;
  padding-right: 0.2702702702702703rem;
  padding-left: 0.5rem;
}
.circlesosomain .circle-cell .circle-cell-name .cname {
  font-size: 0.7567567567567568rem;
}
.circlesosomain .circle-cell .circle-cell-name .cconner {
  font-size: 0.65rem;
  color: #999999;
  padding-top: 0.32rem;
}
.circlesosomain .circle-cell .circle-cell-name .ctext1 {
  font-size: 0.6486486486486487rem;
  color: #999999;
}
.circlesosomain .circle-cell .circle-cell-name .ctext2 {
  font-size: 0.6486486486486487rem;
  color: #999999;
  padding-left: 0.5405405405405406rem;
}
.circlesosomain .circle-cell .circle-cell-fllow {
  float: 3.5;
  padding-top: 0.2702702702702703rem;
  margin-top: 0.2rem;
}
.circlesosomain .circle-cell .circle-cell-fllow button {
  font-size: 0.6216216216216216rem;
  background: #ffbd0a;
  border: none;
  width: 3.2432432432432434rem;
  height: 1.35rem;
  border-radius: 5px;
  display: block;
  color: #fff;
  padding: 0;
}
.circlesosomain .circle-cell .circle-cell-fllow button.active {
  background: #dbdbdb;
  border: none;
}

.nofollowbox {
  padding-top: 7.702703rem;
  text-align: center;
}
.nofollowbox .nofollowpic {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
  margin: 0 auto;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .nosearchtext {
  text-align: center;
  font-size: 0.7567567567567568rem;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/searchcircle.vue